import script from "./UserTableRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserTableRow.vue?vue&type=script&lang=ts&setup=true"

import "./UserTableRow.vue?vue&type=style&index=0&id=040cc6d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-040cc6d5"]])

export default __exports__